module.exports = __webpack_public_path__ + "img/normal.0c8f3db5.svg";